'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*
    TrayNavigation

    Constructs navigation elements and progress indicator for the tray view in
    the member portal. Provides methods to track and set navigation states and
    progress.

    Programmatic initialization of this component is highly recommended.

    HTML Structure:
        div#tray-navigation
            h1.tray-navigation__title Title

    JS initialization:
        $("#tray-navigation").mogo().create("TrayNavigation", { ... arguments ...});

    Arguments:

        progressIndicator (optional) [string]:
            Defaults to "step". Show progress in step or percentage format.

        steps (required) (required) [object]:
            A composite object that describes the menu items of the tray navigation.


    Methods (see methods for additional usage):

        addMenuItem(menuObject, insertBefore)

        removeMenuItem(index)

        isCompleted(index)

        setCompleted(index)

        setIncomplete(index)

        enableEditable(index)

        disableEditable(index)

        setDisabled(index)

        setEnabled(index)

        setIsComplete(testFunction)

        getSelectedIndex()
        
        setSelectedIndex(index)

        deselectIndex(index)

        hideNavigation()

        showNavigation()

        refreshProgressIndicator()

        goToNextStep()

        goToPreviousStep()

        destroy()
*/

function TrayNavigation() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.progressIndicator = 'step'; // step || percent
  this.steps = null;

  this._history = null;
  this._trayContentArea = null;
  this._header = null;
  this._headerContentArea = null;
  this._mainContent = null;
  this._mainContentArea = null;
  this._listItems = [];
  this._sequential = true;
  this._selectedIndex = -1;
  this._invalidStepError = false;
  this._invalidStepErrorTimeout = null;
  this._invalidStepErrorTarget = null;

  this.init = function () {
    // Add Class
    $(this.node).addClass('tray-navigation');

    $(this.node).show();

    // Get History
    this._history = new History();

    // Precheck
    this._precheckParameters();

    // Generate structure
    this._generateTrayStructure();

    // Set selected index
    // this.setSelectedIndex(this._selectedIndex);
  };

  this.initAllReady = function () {
    this._setCurrentIndex();
    $(this.node).css('display', 'block');
    $(window).on('popstate.trayNavigation', this._setCurrentIndex.bind(this));
    $(window).on('pushstate.trayNavigation', this._setCurrentIndex.bind(this));
    $(this.node).append(this._errorTemplate());
  };

  /*
        Adds a menu item to the tray navigation.
         Arguments:
            menuObject [object] (required):
                The menu object that describes the tray navigation menu to be added. See
                class documentation for details.
             insertBefore [integer] (optional):
                The index to insert the menu item to. If not specified, inserts the menu
                item at the end of the tray navigation.
         Returns:
            true if successful, false otherwise.
     */
  this.addMenuItem = function (menuObject, insertBefore) {
    // insertBefore index check
    if (insertBefore > this._listItems.length - 1) insertBefore = null;

    // Title and URL are required
    if (typeof menuObject.title === 'string' && typeof menuObject.url === 'string') {
      var listItem = {};

      listItem.title = menuObject.title;
      listItem.classTitle = menuObject.classTitle;
      listItem.url = menuObject.url;
      listItem.analyticsId = menuObject.analyticsId;
      listItem.completed = false;
      listItem.disabled = false;
      listItem.editable = true;
      listItem.isComplete = null;

      // Generate HTML node
      var title = menuObject.title;

      listItem.node = $("<li class='tray-navigation__item strong'></li>")[0];
      var linkNode = $('<a' + (listItem.classTitle ? ' class=\'' + listItem.classTitle + '\'' : '') + (listItem.analyticsId ? ' data-analytics-id=\'' + listItem.analyticsId + '\'' : '') + '>' + title + '</a>')[0];

      $(linkNode).appendTo(listItem.node);
      $("<div class='icon__svgcheck'></div>").prependTo(linkNode);
      $("<div class='icon__svgarrowright'></div>").appendTo(linkNode);
      $("<div class='icon__svgedit'></div>").appendTo(linkNode);
      if (insertBefore == null) $(listItem.node).appendTo(this._listNode);else $(listItem.node).insertBefore(this._listItems[insertBefore].node);
      // Set link as history node
      this._history.addHistoryNode(linkNode, menuObject.url);

      // Push into memory
      if (insertBefore == null) this._listItems.push(listItem);else this._listItems.splice(insertBefore, 0, listItem);

      // Completed
      if (typeof menuObject.completed === 'boolean' && menuObject.completed == true) {
        this.setCompleted(this._listItems.length - 1);
      }

      // Disabled
      if (typeof menuObject.disabled === 'boolean') listItem.disabled = menuObject.disabled;
      if (listItem.disabled) this.setDisabled(this._listItems.length - 1);

      // Editable
      if (typeof menuObject.editable === 'boolean') listItem.editable = menuObject.editable;
      if (listItem.editable) this.enableEditable(this._listItems.length - 1);

      // Completeness Test
      if (typeof menuObject.isComplete === 'function') {
        this.setIsComplete(this._listItems.length - 1, menuObject.isComplete);
      }

      // Add click handler
      $(linkNode).on('click', $.proxy(this._onClickMenuItem, this));

      // Update index
      if (insertBefore == null) {
        $(linkNode).data('index', this._listItems.length - 1);
      } else {
        for (var i = insertBefore; i < this._listItems.length; i++) {
          $($('a', this._listItems[i].node)[0]).data('index', i);
        }
      }

      // Refresh progress indicator
      this.refreshProgressIndicator();

      return true;
    }
    console.error('TrayNavigation: could not add item, missing title or url');

    return false;
  };

  /*
        Removes a menu item from the tray navigation.
         Arguments:
            index [integer] (required):
                The index of the menu item to be removed.
         Returns:
            true if successful, false otherwise.
    */
  this.removeMenuItem = function (index) {
    if (this._listItems[index] != null) {
      $(this._listItems[index].node).remove();
      $(this._listItems.splice(index, 1));

      if (this._selectedIndex > this._listItems.length - 1) {
        this.setSelectedIndex(this._listItems.length - 1);
      } else {
        this.setSelectedIndex(this._selectedIndex);
      }
      return true;
    }
    return false;
  };

  /*
        Checks if a menu item has been completed.
         Arguments:
            index [integer] (required):
                The index of the menu item to be set to checked.
         Returns:
            true if completed, false otherwise.
    */
  this.isCompleted = function (index) {
    if (this._listItems[index].completed == true) {
      return true;
    }

    return false;
  };

  /*
        Sets a menu item to be completed.
         Arguments:
            index [integer] (required):
                The index of the menu item to be set to completed.
         Returns:
            true if successful, false otherwise.
    */
  this.setCompleted = function (index) {
    if (index >= 0 && index < this._listItems.length) {
      var valid = true;
      if (this._sequential) {
        for (var i = 0; i < index; i++) {
          if (!this._listItems[i].completed) {
            valid = false;
            break;
          }
        }
      }

      if (valid) {
        this._listItems[index].completed = true;
        $(this._listItems[index].node).addClass('completed');
        this.refreshProgressIndicator();
        if (this._sequential) if (index < this._listItems.length - 1) this.setEnabled(index + 1);
        return true;
      }
      console.warn('TrayNavigation: setCompleted, invalid index on sequential navigation');
    } else {
      console.warn('TrayNavigation: setCompleted, index out of range');
    }

    return false;
  };

  /*
        Sets a menu item to be incomplete.
         Arguments:
            index [integer] (required):
                The index of the menu item to be set to incomplete.
         Returns:
            true if successful, false otherwise.
    */
  this.setIncomplete = function (index) {
    if (index >= 0 && index < this._listItems.length) {
      var valid = true;
      if (this._sequential) {
        var lastIndex = -1;
        for (var i = 0; i < this._listItems.length; i++) {
          if (this._listItems[i].completed == true) lastIndex = i;else break;
        }
        if (lastIndex != index) {
          valid = false;
          console.warn('TrayNavigation: setIncomplete, invalid index on sequential navigation');
        } else if (this._selectedIndex > index) {
          valid = false;
          console.warn('TrayNavigation: setIncomplete, index would cause selected index to be invalid');
        }
      }

      if (valid) {
        this._listItems[index].completed = false;
        $(this._listItems[index].node).removeClass('completed');
        this.refreshProgressIndicator();
        if (this._sequential) if (index < this._listItems.length - 1) this.setDisabled(index + 1);
        return true;
      }
    } else {
      console.warn('TrayNavigation: setIncomplete, index out of range');
    }

    return false;
  };

  /*
        Displays the edit icon on a menu item that is completed.
         Arguments:
            index [integer] (required):
                The index of the menu item where the edit icon should be displayed.
         Returns:
            true if successful, false otherwise.
    */
  this.enableEditable = function (index) {
    if (index < this._listItems.length && index >= 0) {
      $(this._listItems[index].node).addClass('editable');
      this._listItems[index].editable = true;
      return true;
    }
    console.warn('TrayNavigation: enableEditable, index out of range');
    return false;
  };

  /*
        Does not show the edit icon on completed items (the edit icon is usually
        shown only on completed items).
         Arguments:
            index [integer] (required):
                The index of the menu item where the edit icon should not be displayed.
         Returns:
            true if successful, false otherwise.
    */
  this.disableEditable = function (index) {
    if (index < this._listItems.length && index >= 0) {
      $(this._listItems[index].node).removeClass('editable');
      this._listItems[index].editable = false;
      return true;
    }
    console.warn('TrayNavigation: disableEditable, index out of range');
    return false;
  };

  /*
        Disabled a menu item.
         Arguments:
            index [integer] (required):
                The index of the menu item to be set to disabled.
         Returns:
            true if successful, false otherwise.
    */
  this.setDisabled = function (index) {
    if (index < this._listItems.length && index >= 0) {
      this._listItems[index].disabled = true;
      $(this._listItems[index].node).addClass('disabled');
      var aLink = $('a', this._listItems[index].node)[0];
      this._history.disableHistoryNode(aLink);
      $(aLink).attr('tabindex', -1);
      $(aLink).attr('aria-disabled', 'true');
      return true;
    }
    console.warn('TrayNavigation: setDisabled, index out of range');

    return false;
  };

  /*
        Enables a menu item.
         Arguments:
            index [integer] (required):
                The index of the menu item to be set to enabled.
         Returns:
            true if successful, false otherwise.
    */
  this.setEnabled = function (index) {
    if (index < this._listItems.length && index >= 0) {
      var valid = true;
      if (this._sequential) {
        for (var i = 0; i < index; i++) {
          if (!this._listItems[i].completed) {
            valid = false;
            break;
          }
        }
      }

      if (valid) {
        this._listItems[index].disabled = false;
        $(this._listItems[index].node).removeClass('disabled');
        var aLink = $('a', this._listItems[index].node)[0];
        this._history.enableHistoryNode(aLink);
        $(aLink).removeAttr('tabindex');
        $(aLink).removeAttr('aria-disabled');
        return true;
      }
      console.warn('TrayNavigation: setEnabled, invalid index on sequential navigation');
    } else {
      console.warn('TrayNavigation: setEnabled, index out of range');
    }
    return false;
  };

  /*
        Assigns a completeness test to a menu item. The test should be a function that returns a boolean.
         Arguments:
            index [integer] (required):
                The index of the menu item to assign the completeness test.
            testFunction [function] (required):
                The function to be assigned as the completeness test.
         Returns:
            true if successful, false otherwise.
    */
  this.setIsComplete = function (index, testFunction) {
    if (typeof testFunction === 'function' && index < this._listItems.length && index >= 0) {
      this._listItems[index].isComplete = testFunction;
      return true;
    }
    return false;
  };

  /*
        Uses each step's isComplete() test (if defined) to appropriately set whether each step is complete or not
    */
  this.fixStepsCompletion = function () {
    var menuItems = this._listItems;
    var firstIncompleteEncountered = false;
    for (var index = 0; index < menuItems.length; index++) {
      var menuItem = menuItems[index];
      if (menuItem.isComplete) {
        if (menuItem.isComplete()) {
          this.setCompleted(index);
        } else {
          this.setIncomplete(index);
          if (firstIncompleteEncountered) {
            this.setDisabled(index);
          }
          firstIncompleteEncountered = true;
          if (this._sequential) break;
        }
      }
    }
  };

  /*
        Get the index of the currently selected tray navigation menu.
         Returns:
            [integer]
                The index of the selected menu item.
    */
  this.getSelectedIndex = function () {
    return this._selectedIndex;
  };

  /*
        Select a tray navigation menu item given the index.
         Arguments:
            index [integer] (required):
                The index of the menu item to be set to selected.
         Returns:
            true if successful, false otherwise.
    */
  this.setSelectedIndex = function (index) {
    if (index < this._listItems.length && index >= -1) {
      var valid = true;
      if (this._sequential) {
        for (var i = 0; i < index; i++) {
          if (!this._listItems[i].completed) {
            valid = false;
            break;
          }
        }
      }

      if (valid) {
        this._selectedIndex = index;
        for (var i = 0; i < this._listItems.length; i++) {
          $(this._listItems[i].node).removeClass('selected');
        }if (index != -1) {
          $(this._listItems[this._selectedIndex].node).addClass('selected');
          if ($('#' + this.id + '_ProgressBar').mogo().create == undefined) this.refreshProgressIndicator();
        }
        return true;
      }
      console.warn('TrayNavigation: setSelectedIndex, invalid index on sequential navigation');
      return false;
    }
    console.warn('TrayNavigation: setSelectedIndex, index out of range');
    return false;
  };

  /*
        Deselects the navigation menu items.
    */
  this.deselectIndex = function (index) {
    $(this._listItems[index].node).removeClass('selected');
  };

  /*
        Shows the navigation menu items.
    */
  this.showNavigation = function () {
    $('.tray-navigation__items', this.node).css('display', 'block');
  };

  /*
        Hides the navigation menu items.
    */
  this.hideNavigation = function () {
    $('.tray-navigation__items', this.node).css('display', 'none');
  };

  /*
        Refreshes the progress indicator.
    */
  this.refreshProgressIndicator = function () {
    if ($('#' + this.id + '_ProgressBar').length > 0) {
      // Update num items
      if (this._listItems.length != $('#' + this.id + '_ProgressBar').mogo().numSteps) this._createProgressIndicator();else {
        // Update progress
        var stepsComplete = 0;
        for (var i = 0; i < this._listItems.length; i++) {
          if (this._listItems[i].completed != undefined && this._listItems[i].completed == true) stepsComplete++;
        }$('<div id=\'' + this.id + '_ProgressBar\'></div>').mogo().setProgress(stepsComplete);
      }
    }
  };

  /*
        Navigates to the next menu item's url.
         Arguments:
            nextIncomplete [boolean] (optional):
                Defaults to false.
         Returns:
            true if the next step is valid, false otherwise.
    */
  this.goToNextStep = function (nextIncomplete) {
    var index = this._selectedIndex + 1;
    if (nextIncomplete) {
      while (this._listItems[index].completed && index < this._listItems.length - 1) {
        index += 1;
      }
    }
    if (index >= this._listItems.length) return false;
    return true, this._history.goToUrl(this._listItems[index].url, null, null);
  };

  /*
        Navigates to the previous menu item's url.
         Arguments:
            none
         Returns:
            true if the previous step is valid, false otherwise.
    */
  this.goToPreviousStep = function () {
    var index = this._selectedIndex - 1;
    if (index < 0) return false;
    return true, this._history.goToUrl(this._listItems[index].url, null, null);
  };

  /*
        Removes event listeners set on window or document.
    */
  this.destroy = function () {
    $(window).off('pushstate.trayNavigation');
    $(window).off('popstate.trayNavigation');
  };

  this._createProgressIndicator = function () {
    // Destroy if already exists
    if ($('#' + this.id + '_ProgressBar').length > 0) $('#' + this.id + '_ProgressBar').mogo().destroy();

    var stepsComplete = 0;
    for (var i = 0; i < this._listItems.length; i++) {
      if (this._listItems[i].completed != undefined && this._listItems[i].completed == true) stepsComplete++;
    }$('<div id=\'' + this.id + '_ProgressBar\'></div>').appendTo(this._headerContentArea);
    $('#' + this.id + '_ProgressBar').mogo().create('ProgressIndicator', {
      type: this.progressIndicator,
      initialValue: stepsComplete,
      numSteps: this._listItems.length
    });
  };

  this._generateTrayStructure = function () {
    // Detach children
    var children = $(this.node).children().detach();

    // Generate tray content area
    this._trayContentArea = $("<div class='tray-navigation__tray-content'></div>");
    $(this._trayContentArea).appendTo(this.node);

    // Generate header content area
    this._header = $("<div class='tray-navigation__header-content'></div>");
    $(this._header).appendTo(this._trayContentArea);
    var tmp = $("<div class='row'></div>");
    $(tmp).appendTo(this._header);
    this._headerContentArea = $("<div class='small-12 columns clearfix'></div>");
    $(this._headerContentArea).appendTo(tmp);

    // Generate main content area
    this._mainContent = $("<div class='tray-navigation__main-content'></div>");
    $(this._mainContent).appendTo(this._trayContentArea);
    var tmp = $("<div class='row'></div>");
    $(tmp).appendTo(this._mainContent);
    this._mainContentArea = $("<div class='small-12 columns'></div>");
    $(this._mainContentArea).appendTo(tmp);

    // Re-attach children to main content area
    children.prependTo(this._mainContent);

    // HEADER CONTENT

    // Move title to header content area
    var title = $('h1.tray-navigation__title', this.node).detach();
    title.appendTo(this._headerContentArea);

    // Add hr if title exists
    if ($('.tray-navigation__title', this.node).length > 0) {
      $($('.tray-navigation__title', this.node)[0]).after("<hr class='tray-navigation__separator hide-for-medium-only'>");
    }

    // MAIN CONTENT
    this._listNode = $("<ul class='tray-navigation__items'></ul>");
    $(this._listNode).appendTo(this._mainContentArea);

    // Generate menu items
    for (var i = 0; i < this.steps.items.length; i++) {
      this.addMenuItem(this.steps.items[i]);
    }

    // Disable menu items index completed + 2 (for sequential)
    if (this._sequential) {
      var compInd = -1;
      for (var i = 0; i < this._listItems.length; i++) {
        if (!this._listItems[i].completed) break;else compInd++;
      }
      for (var i = compInd + 2; i < this._listItems.length; i++) {
        this.setDisabled(i);
      }
    }

    // Finally, create Progress Indicator component, after items generated (HEADER)
    this._createProgressIndicator();
  };

  this._precheckParameters = function () {
    // Check steps items
    if (this.steps != null && _typeof(this.steps) === 'object') {
      // Check sequential
      if (this.steps.sequential != null && this.steps.sequential === false) this._sequential = false;

      // Check items
      if (!(this.steps.items instanceof Array)) {
        this.steps = [];
        console.error('TrayNavigation: items in steps not of type Array');
      } else {
        for (var i = 0; i < this.steps.items.length; i++) {
          if (this.steps.items[i].title == null || this.steps.items[i].url == null) {
            this.steps.items.splice(i, 1);
            i--;
            console.error('TrayNavigation: could not add item, missing title or url');
          }
        }
      }

      // Check selected index
      if (this.steps.selectedIndex == null) this.steps.selectedIndex = -1;
      this._selectedIndex = Math.max(-1, this.steps.selectedIndex);
      this._selectedIndex = Math.min(this._selectedIndex, this.steps.items.length - 1);
    } else {
      this.steps = {};
      this.steps.items = [];
    }
  };

  this._onClickMenuItem = function (e) {
    var target = e.originalEvent.currentTarget;
    if ($(target).data('history-disabled') == true && !$(target).parent().hasClass('selected') && !$(target).parent().hasClass('completed')) {
      if (this._invalidStepError) {
        clearTimeout(this._invalidStepErrorTimeout);
        $(this._invalidStepErrorTarget).removeClass('tray-navigation__invalid-step-error-item');
      }
      $(target).addClass('tray-navigation__invalid-step-error-item');
      $('#invalid-step-error').insertAfter($(target));
      $('#invalid-step-error').slideDown();
      this._invalidStepError = true;
      this._invalidStepErrorTarget = target;
      this._invalidStepErrorTimeout = setTimeout(this._hideError.bind(this, target), 3000);
    } else {
      if ($(target).data('history-disabled') == true) return false;
      this.setSelectedIndex($(target).data('index'));
    }
  };

  this._setCurrentIndex = function () {
    var path = location.pathname;
    var index = -1;
    for (var i in this._listItems) {
      index++;
      if (this._listItems[i].url === path) {
        this.setSelectedIndex(index);
        return;
      }
    }
  };

  this._errorTemplate = function () {
    return "<div id='invalid-step-error' class='tray-navigation__invalid-step-error'>" + "<div class='icon icon--warning'></div>" + "<div class='description'>Woah there, one step at a time.</div>" + '</div>';
  };

  this._hideError = function (target) {
    this._invalidStepError = false;
    $(target).removeClass('tray-navigation__invalid-step-error-item');
    $('#invalid-step-error').slideUp();
  };
}